import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, mergeMap, Observable, startWith } from 'rxjs';

export function getDataFromRoute(router: Router, activatedRoute: ActivatedRoute): Observable<any> {
  return router.events.pipe(
    filter((e) => e instanceof NavigationEnd),
    startWith(null),
    mergeMap(() => {
      let current = activatedRoute.root;
      while (current.firstChild) {
        current = current.firstChild;
      }
      return current.data;
    }),
  );
}
